export enum AuthPaths {
  login = 'login',
  confirmNewUser = 'confirm-new-user',
  confirmPasswordReset = 'confirm-password-reset',
  confirmForcePasswordChange = 'confirm-force-password-change',
  forgotPassword = 'forgot-password',
  confirmMfa = 'confirm-mfa',
  saml = "saml"
}
